
export const logLevel = Object.freeze({
  DEBUG: 'DEBUG',
  ERROR: 'ERROR',
  INFO: 'INFO',
  WARN: 'WARN',
});

export const transactions = Object.freeze([
  'SCREEN_TO_SCREEN',
]);

export const transactionSeq = Object.freeze({
  START: 'START',
  STOP: 'STOP',
  CONTINUE: 'CONTINUE',
});

export const RTM_LEARNER_PLUGIN_LOG = 'learner.plugin.log';
export const RTM_LEARNER_PLUGIN_LOG_OK = 'learner.plugin.log.ok';
export const RTM_LEARNER_PLUGIN_LOG_ERROR = 'learner.plugin.log.error';
